export enum HsaAdyenOnboardingStatus {
  Pending = "pending",
  InProgress = "in_progress",
  ActionNeeded = "action_needed",
  Completed = "completed",
}
